import { render, staticRenderFns } from "./NewInvestment.vue?vue&type=template&id=57f1b39d&"
import script from "./NewInvestment.vue?vue&type=script&lang=js&"
export * from "./NewInvestment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports